import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, QRResponseDataSchema, UpsertQRSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof QRResponseDataSchema>>

export function useUpsertQRMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ name, id }: z.input<typeof UpsertQRSchema> & { id?: string }) => {
      if (id) {
        const response = await axios.post<Response>(`/integrations/qr/${id}`, {
          name,
        })

        return response.data
      } else {
        const response = await axios.post<Response>("/integrations/qr/", {
          name,
        })

        return response.data
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["qr"] })
    },
  })
}
